import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "./AxiosInstance";

const initialState = {
  posts: [],
  status: "idle",
  error: null,
};

// JSON-body sibling of dynamicTokenPost (DynamicTokenPostSlice.jsx) — for the
// handful of endpoints that expect a raw JSON body (sometimes an array, e.g.
// AddLoanApplicationDetails) instead of multipart FormData. Same cookie-based
// auth via axiosInstance, no token needed.
export const dynamicTokenPostJson = createAsyncThunk(
  "postsJson/fetchPosts",
  async ({ url, data }) => {
    try {
      const response = await axiosInstance.post(url, data, {
        headers: { "Content-Type": "application/json" },
      });

      return response && response.data;
    } catch (error) {
      console.error("Error posting JSON:", error);
      throw error;
    }
  }
);

const dynamicTokenPostJsonSlice = createSlice({
  name: "postsJson",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(dynamicTokenPostJson.pending, (state) => {
        state.status = "loading";
      })
      .addCase(dynamicTokenPostJson.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.posts = action.payload;
      })
      .addCase(dynamicTokenPostJson.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      });
  },
});

export default dynamicTokenPostJsonSlice.reducer;
